module.exports = __webpack_public_path__ + "static/media/section5_img1.fe4ed2e5.jpg";